import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack, Typography } from "@mui/material";
import { Loader } from "../../../shared";
import { errorMessage, successMessage } from "../../../utils";
import { getUberEatsConnectionApi } from "../api";

export const UberEatsCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const verifyConnection = async () => {
      const callbackError =
        searchParams.get("error") || searchParams.get("message");
      try {
        const res = await getUberEatsConnectionApi();
        if (res.success && res.data?.connected && !res.data?.reconnect_required) {
          successMessage("Uber Eats connected successfully.");
        } else {
          errorMessage(callbackError || "Uber Eats connection failed.");
        }
      } catch (err) {
        errorMessage(
          callbackError ||
            err?.response?.data?.message ||
            "Uber Eats connection failed."
        );
      } finally {
        navigate("/ubereats", { replace: true });
      }
    };
    verifyConnection();
  }, []);

  return (
    <Box
      sx={{
        height: "70vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Stack alignItems="center" gap="16px">
        <Loader />
        <Typography variant="subtitle1" fontWeight={600}>
          Verifying Uber Eats connection...
        </Typography>
      </Stack>
    </Box>
  );
};
